import { AppThunkAction } from '../reducers';

// services
import * as Services from '../../services/ProtocolConsumptionSyncAnalysis.Service';

// models
import {
	SyncAnalysis,
	ISyncAnalysisFindingsFilters,
} from '../../models/Entities/Protocols/SyncAnalysis';
import { ErrorType } from '../../models/HttpError';

// actions
import * as Actions from '../actions';

export { SYNC_ANALYSIS_FINDINGS_DEFAULT_PAGE_SIZE } from '../../services/ProtocolConsumptionSyncAnalysis.Service';

type KnownAction =
	| Actions.ProtocolConsumptionSyncAnalysis.SyncAnalysisGetRequestAction
	| Actions.ProtocolConsumptionSyncAnalysis.SyncAnalysisGetSuccessAction
	| Actions.ProtocolConsumptionSyncAnalysis.SyncAnalysisGetFailureAction
	| Actions.ProtocolConsumptionSyncAnalysis.SyncAnalysisGetFindingsRequestAction
	| Actions.ProtocolConsumptionSyncAnalysis.SyncAnalysisGetFindingsSuccessAction
	| Actions.ProtocolConsumptionSyncAnalysis.SyncAnalysisGetFindingsFailureAction;

const Unauthorized: ErrorType = {
	ErrorCode: 401,
	ErrorMessage: 'Not authorized',
	Errors: [],
};

const GetProtocolConsumptionSyncAnalysis = (
	syncProcessId: string
): AppThunkAction<KnownAction> => async (dispatch, getState) => {
	const state = getState();
	const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

	if (token === null) {
		dispatch({ type: 'SYNCANALYSIS_GET_FAILURE', syncProcessId, error: Unauthorized });
		return;
	}

	dispatch({ type: 'SYNCANALYSIS_GET_REQUEST', syncProcessId });

	try {
		const analysis: SyncAnalysis | null = await Services.GetProtocolConsumptionSyncAnalysis(
			syncProcessId,
			token
		);
		dispatch({ type: 'SYNCANALYSIS_GET_SUCCESS', syncProcessId, analysis });
	} catch (error) {
		dispatch({ type: 'SYNCANALYSIS_GET_FAILURE', syncProcessId, error: error as ErrorType });
	}
};

const GetProtocolConsumptionSyncAnalysisFindings = (
	analysisId: string,
	pageNumber?: number,
	pageSize?: number,
	filters?: ISyncAnalysisFindingsFilters
): AppThunkAction<KnownAction> => async (dispatch, getState) => {
	const state = getState();
	const token: string | null = state?.oidc?.user?.access_token ? state.oidc.user.access_token : null;

	if (token === null) {
		dispatch({ type: 'SYNCANALYSIS_GETFINDINGS_FAILURE', analysisId, error: Unauthorized });
		return;
	}

	dispatch({ type: 'SYNCANALYSIS_GETFINDINGS_REQUEST', analysisId });

	try {
		const page = await Services.GetProtocolConsumptionSyncAnalysisFindings(
			analysisId,
			token,
			pageNumber,
			pageSize,
			filters
		);
		dispatch({
			type: 'SYNCANALYSIS_GETFINDINGS_SUCCESS',
			analysisId,
			findings: page.findings,
			paginationState: page.paginationState,
		});
	} catch (error) {
		dispatch({ type: 'SYNCANALYSIS_GETFINDINGS_FAILURE', analysisId, error: error as ErrorType });
	}
};

export const ActionCreators = {
	GetProtocolConsumptionSyncAnalysis,
	GetProtocolConsumptionSyncAnalysisFindings,
};
